/*
 * @Descripttion: 
 * @version: 2.0.0
 * @Author: ck
 * @Date: 2019-09-11 10:36:24
 * @LastEditors: ck
 * @LastEditTime: 2019-10-29 10:29:33
 */
import '@babel/polyfill';
import 'classlist-polyfill';
// import 'babel-polyfill'
// require('es6-promise').polyfill();
import 'intersection-observer'
import Vue from 'vue'
import App from './App'
import router from './routers'
import * as filters from '@/common/filters.js'
import * as component from '@/components/index.js'
import 'normalize.css'
// import 'animate.css'
// import store from './store'
import Method from "@/plugin/fn"
import Meta from 'vue-meta'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import '@/styles/common.scss'



Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper, /* { default global options } */ )
Vue.use(Method)
Vue.use(Meta)

//注册全局组件
Object.keys(component).forEach(key => {
    Vue.component(key, component[key])
})
//注册全局过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})



/* eslint-disable no-new */
let main = new Vue({
    el: '#app',
    router,
    // store,
    render: h => h(App),
    mounted() {
        document.dispatchEvent(new Event('render-event'))
    }
})

export default main